/**
 * CustomisationModal - Extends ModalDialog for the "Book a Call" functionality
 * 
 * This component handles opening/closing the customisation call modal
 * when the CTA button is clicked in the product-customisation section.
 */

if (!customElements.get('customisation-modal')) {
  customElements.define(
    'customisation-modal',
    class CustomisationModal extends ModalDialog {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);
        this.trackModalOpen();
      }

      hide() {
        super.hide();
      }

      /**
       * Track modal opens for analytics
       * This allows us to measure interest in the "Book a Call" feature
       */
      trackModalOpen() {
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'customisation_call_modal_open',
            product_title: document.querySelector('.product__title h1')?.textContent?.trim() || ''
          });
        }
      }
    }
  );
}

/**
 * Initialise CTA button click handlers
 * Connects the section's CTA button to the modal
 */
document.addEventListener('DOMContentLoaded', function() {
  const ctaButtons = document.querySelectorAll('[data-customisation-cta]');
  
  ctaButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Find the modal - it gets moved to body by ModalDialog.connectedCallback
      const modal = document.querySelector('customisation-modal');
      if (modal) {
        modal.show(button);
      }
    });
  });
});
